import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CSSStyle } from '../http/cssStyle';
import agent from '../../assets/agents/default-q11.json'
import { Renderer2 } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class CssService {
    public properties?: CSSStyle;
    private root: HTMLElement;


    constructor(
        private http: HttpClient,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.root = this.document.getElementsByTagName('app-q11bot')[0] as HTMLElement
    }

    maximizeScreen(chatHeight: string, expanded: boolean) {
        const root = this.document.documentElement;
        if (expanded) {
            this.root.style.setProperty('--q11-chatbot-height', '75vh')
        }
        else if (chatHeight == "3") {
            this.root.style.setProperty('--q11-chatbot-height', '71vh')
        } else if (chatHeight == "2") {
            this.root.style.setProperty('--q11-chatbot-height', '60vh')

        } else if (chatHeight == "1") {
            this.root.style.setProperty('--q11-chatbot-height', '50vh')
        }
    }

    updateCSS(properties: CSSStyle, chatHeight: string) {
        this.properties = properties
        const root = this.document.documentElement;
        this.root.style.setProperty('--q11-global-font', properties.chat_font_style);
        this.root.style.setProperty('--q11-chat-title-bar-color', properties.chat_title_bar_color)
        this.root.style.setProperty('--q11-chat-title-bar-font-color', properties.chat_title_bar_font_color)
        this.root.style.setProperty('--q11-chat-background-color', properties.chat_background_color)
        if (properties.response_message_background_color == agent.response_message_background_color) {
            //If response message was not changed from teh default use customer message background
            this.root.style.setProperty('--q11-customer-message-background', properties.customer_message_background)
        } else {
            //It was changed so use it 
            this.root.style.setProperty('--q11-customer-message-background', properties.response_message_background_color)
        }
        this.root.style.setProperty('--q11-chips-font-color', properties.chips_font_color)
        this.root.style.setProperty('--q11-button-color', properties.button_color)
        this.root.style.setProperty('--q11-button-background-color', properties.button_background_color)
        this.root.style.setProperty('--q11-button-logo-size', String(properties.button_logo_size) + 'em')
        this.root.style.setProperty('--q11-user-message-background', properties.user_message_background_color)
        this.root.style.setProperty('--q11-user-font-color', properties.user_font_color)

        if (chatHeight == "3") {
            this.root.style.setProperty('--q11-chatbot-height', '71vh')
        } else if (chatHeight == "2") {
            this.root.style.setProperty('--q11-chatbot-height', '60vh')

        } else if (chatHeight == "1") {
            this.root.style.setProperty('--q11-chatbot-height', '50vh')
        }
    }
    /*
    updateCSS(root: {}, renderer: Renderer2, properties: CSSStyle) {
        renderer.setStyle(root, '--q11-global-font', properties.chat_font_style)
        renderer.setStyle(root, '--q11-chat-title-bar-color', '#000000')
        renderer.setStyle(root, '--q11-chat-title-bar-font-color', properties.chat_title_bar_font_color)
        renderer.setStyle(root, '--q11-chat-background-color, properties.chat_background_color)
        renderer.setStyle(root, '--q11-customer-message-background', properties.customer_message_background)
        renderer.setStyle(root, '--q11-chips-font-color', properties.chips_font_color)
        renderer.setStyle(root, '--q11-button-color', properties.button_color)
        renderer.setStyle(root, '--q11-button-background-color', properties.button_background_color)
    }
    */
}